module.exports = __webpack_public_path__ + "media/img/about/social/linkedin-2e4c2bfb28986b37d1d90107b224c599.png";